<template>
  <div class="footer">
    <div class="footer__content">
      <div class="column">
        <div class="column__title">
          <span>Statzon</span>
        </div>
        <div class="column__content">
          <ul>
            <li>Kaivokatu 12</li>
            <li>Helsinki, Finland</li>
            <li>VAT FI29357054</li>
            <li style="margin-top: 2rem;"><a href="mailto:info@statzon.com" class="link--white_altB">info@statzon.com</a></li>
            <li>+358 504 713 021</li>
          </ul>
        </div>

        <div class="column__copyright">
          <p>&copy; 2024 Statzon</p>
        </div>
      </div>

      <div class="column">
        <div class="column__title">
          <span>Services</span>
        </div>
        <div class="column__content">
          <ul>
            <li><a href="" class="link--white_altB"></a></li>
            <li><a href="https://statzon.com/market-intelligence-as-a-service" class="link--white_altB">Market Intelligence as a Service</a></li>
            <li><a href="https://ai.statzon.com" class="link--white_altB">Statzon AI</a></li>
            <li><a href="https://statzon.com/pricing" class="link--white_altB">Pricing</a></li>
            <li><a href="https://statzon.com/data-providers" class="link--white_altB">Data Providers</a></li>
            <li><a href="https://statzon.com/academic-access" class="link--white_altB">Academic Access</a></li>
            <li><a href="https://statzon.com/tech360" class="link--white_altB">Tech 360 Newsletter</a></li>
            <li><a href="https://statzon.com/insighttech-podcast" class="link--white_altB">InsightTech Podcast</a></li>
          </ul>
        </div>
      </div>

      <div class="column">
        <div class="column__title">
          <span>Company</span>
        </div>
        <div class="column__content">
          <ul>
            <li><a href="https://statzon.com/customer-case-stories" class="link--white_altB">Customer Stories</a></li>
            <li><a href="https://statzon.com/news" class="link--white_altB">News</a></li>
            <li><a href="https://statzon.com/contact-us" class="link--white_altB">Contact Us</a></li>
            <li><a href="https://statzon.com/about-us" class="link--white_altB">About Us</a></li>
            <li><a href="https://statzon.com/media" class="link--white_altB">Statzon in Media</a></li>
            <li><a href="https://statzon.com/become-a-data-partner" class="link--white_altB">Become a Data Partner</a></li>
          </ul>
        </div>
      </div>

      <div class="column">
        <div class="column__title">
          <span>Support</span>
        </div>
        <div class="column__content">
          <ul>
            <li><a href="https://statzon.com/help-center" class="link--white_altB">Help Center</a></li>
            <li><a href="https://statzon.com/how-to-cite-statzon" class="link--white_altB">How to Cite Statzon</a></li>
          </ul>
        </div>

        <div class="column__title">
          <span>Legal</span>
        </div>
        <div class="column__content">
          <ul>
            <li><a href="https://statzon.com/privacy-policy-and-gdpr" class="link--white_altB">Privacy Policy</a></li>
            <li><a href="https://statzon.com/terms-and-conditions" class="link--white_altB">Terms and Conditions</a></li>
          </ul>
        </div>
      </div>

      <div class="column">
        <div class="column__title">
          <span>Social</span>
        </div>
        <div class="column__content">
          <ul>
            <li><a href="https://www.linkedin.com/company/statzon" class="link--white_altB">LinkedIn</a></li>
            <li><a href="https://www.instagram.com/statzon/" class="link--white_altB">Instagram</a></li>
            <li><a href="https://www.youtube.com/@statzon" class="link--white_altB">YouTube</a></li>
            <li><a href="https://www.facebook.com/statzon" class="link--white_altB">Facebook</a></li>
            <li><a href="https://x.com/Statzon1" class="link--white_altB">X</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from '@/components/form/Input.vue'

export default {
  components: {
    FormInput
  },
  data () {
    return {
      newsletter: '',
      newsletterError: '',
      newsletterSuccess: ''
    }
  },
  computed: {
    currentRouteName () {
      return this.$route.name
    }
  },
  methods: {
    async subscribe () {
      this.newsletterError = ''
      let valid = true
      let emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (this.newsletter === '') {
        this.newsletterError = 'Email field cannot be empty'
        valid = false
      } else if (!emailTest.test(this.newsletter)) {
        this.newsletterError = 'Invalid Email address'
        valid = false
      }

      if (valid) {
        let formData = {
          email: this.newsletter
        }

        try {
          await this.$store.dispatch('app/newsletter', formData)
          this.formLoading = false
          this.contactForm = false
          this.newsletterSuccess = 'Thank you for subscribing!'
          this.newsletter = ''
        } catch (error) {
          this.formLoading = false
          if (error.data) {
            if (error.data.errors) { this.newsletterError = error.data.errors }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.footer {
  @include font('content--md', $white, 0.9);
  position: relative;
  bottom: 0px;
  width: 100%;
  height: auto;
  background-color: #272B2F;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpath fill='%23232629' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%231f2122' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%231a1d1c' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%23161815' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%2312130F' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23161815' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%231a1d1c' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%231f2122' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23232629' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23272B2F' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  border-top: 2px solid $black;
  //box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23); // TODO: Tweak...

  @media screen and (min-width: $breakpointSm) {
    position: absolute;
    bottom: 0px;
    height: 400px;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
  }

  &__content {
    width: 100%;
    max-width: $xlContentWidth;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    @media screen and (min-width: $breakpointSm) {
      flex-direction: row;
      text-align: left;
    }
  }
}

.column {
  width: calc(100% - 2rem);
  margin: 2rem 1rem;

  &__title {
    text-transform: uppercase;
    color: $white;
    margin: 1rem 0 0 0;
    width: auto;

    span {
      border-bottom: 1px dashed $blue;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;

    ul {
      list-style: none;
      padding: 0;
      margin: 0.5rem 0;
    }

    li {
      margin: 0.5rem 0;
    }
  }

  &__copyright {
    position: absolute;
    bottom: 0px;
  }
}
</style>
